import { render, staticRenderFns } from "./veStuHygieneStudent.vue?vue&type=template&id=3ada0730&scoped=true"
import script from "./veStuHygieneStudent.vue?vue&type=script&lang=js"
export * from "./veStuHygieneStudent.vue?vue&type=script&lang=js"
import style0 from "./veStuHygieneStudent.vue?vue&type=style&index=0&id=3ada0730&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ada0730",
  null
  
)

export default component.exports